"use client";

import AuthButtonSkeleton from "@/app/(discover)/components/auth-button-skeleton";
import ProfileButtonWrapper from "@/app/(discover)/components/profile-button-wrapper";
import SignInButtonWrapper from "@/app/(discover)/components/sign-in-button-wrapper";
import SignUpButtonWrapper from "@/app/(discover)/components/sign-up-button-wrapper";
import { useAuth } from "@/stores/use-auth";

function renderAuthButtons(showSkeleton: boolean, isAuthenticated: boolean) {
  if (showSkeleton) {
    return <AuthButtonSkeleton />;
  }

  if (isAuthenticated) {
    return <ProfileButtonWrapper />;
  }

  return (
    <>
      <SignInButtonWrapper />
      <SignUpButtonWrapper />
    </>
  );
}

export default function AuthButtonGroup() {
  const { isLoading, isAuthenticated } = useAuth();

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      {renderAuthButtons(isLoading, isAuthenticated)}
    </div>
  );
}
